module.exports = __webpack_public_path__ + "static/img/goods.f3d62679.png";